// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"126":"results-restored","575":"results"}[chunkId] || chunkId) + "." + {"5":"7713a5d2","14":"1875454d","126":"a219f3b4","237":"02153557","575":"c06f10db","728":"48927a28"}[chunkId] + ".chunk.js";
};